import React, { useState } from 'react';
import { Play, X } from 'lucide-react';
import { videos } from '../data/mock';

const VideoReel = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  const openVideoModal = (video) => {
    setSelectedVideo(video);
    document.body.style.overflow = 'hidden';
  };

  const closeVideoModal = () => {
    setSelectedVideo(null);
    document.body.style.overflow = 'unset';
  };

  return (
    <section id="videos" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="font-poppins text-xs tracking-[0.4em] text-gray-400 mb-4 block">
            MEDIA
          </span>
          <h2 className="font-bebas text-5xl md:text-6xl tracking-wider">
            Video Reel
          </h2>
        </div>

        {/* Video Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {videos.map((video) => (
            <div
              key={video.id}
              onClick={() => openVideoModal(video)}
              className="group relative aspect-video overflow-hidden cursor-pointer bg-gray-100"
            >
              <img
                src={video.thumbnail}
                alt={video.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-black/30 group-hover:bg-black/50 transition-all duration-300" />
              
              {/* Play Button */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-16 h-16 md:w-20 md:h-20 rounded-full border-2 border-white/80 flex items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:border-white group-hover:bg-white/20">
                  <Play className="w-6 h-6 md:w-8 md:h-8 text-white ml-1" fill="white" />
                </div>
              </div>
              
              {/* Duration Badge */}
              <div className="absolute bottom-4 right-4 bg-black/70 px-3 py-1">
                <span className="font-poppins text-white text-xs">{video.duration}</span>
              </div>
              
              {/* Title */}
              <div className="absolute bottom-4 left-4">
                <h3 className="font-bebas text-white text-xl tracking-wider">
                  {video.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Video Modal */}
      {selectedVideo && (
        <div 
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center"
          onClick={closeVideoModal}
        >
          {/* Close Button */}
          <button
            onClick={closeVideoModal}
            className="absolute top-6 right-6 text-white/70 hover:text-white transition-colors z-50 p-2"
            aria-label="Close video"
          >
            <X size={32} strokeWidth={1} />
          </button>

          {/* Video Content */}
          <div 
            className="relative max-w-4xl w-full mx-4"
            onClick={(e) => e.stopPropagation()}
          >
            {selectedVideo.videoUrl ? (
              <video
                src={selectedVideo.videoUrl}
                controls
                autoPlay
                className="w-full aspect-video bg-black"
              />
            ) : (
              <div className="aspect-video bg-neutral-900 flex flex-col items-center justify-center">
                <img 
                  src={selectedVideo.thumbnail} 
                  alt={selectedVideo.title}
                  className="absolute inset-0 w-full h-full object-cover opacity-30"
                />
                <div className="relative z-10 text-center p-8">
                  <div className="w-20 h-20 rounded-full border-2 border-white/50 flex items-center justify-center mx-auto mb-6">
                    <Play className="w-10 h-10 text-white/50 ml-1" />
                  </div>
                  <h3 className="font-bebas text-white text-3xl tracking-wider mb-2">
                    {selectedVideo.title}
                  </h3>
                  <p className="font-poppins text-white/60 text-sm mb-4">
                    Duration: {selectedVideo.duration}
                  </p>
                  <p className="font-poppins text-white/40 text-sm">
                    Video file will be uploaded soon
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default VideoReel;
